import React from 'react';
import styled from 'styled-components';
import { Dropdown, useDropdown } from '@trevor/ui-components';
import { SavedQuery } from '@/types';
import { SavedQueryButton as SavedQueryButtonBase } from './SavedQueryButton';
import { SavedQueryLabel } from './SavedQueryLabel';
import { DropdownContent } from './DropdownContent';

export type Props = {
  name: SavedQuery['name'];
  series: SavedQuery['series'];
};

const SavedQueryButton = styled(SavedQueryButtonBase)`
  align-items: center;
  background-color: #fff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  display: flex;
  font-size: 12px;
  line-height: 18px;
  padding: 6px 8px;
  white-space: nowrap;

  & > svg {
    margin-left: 10px;
  }

  &:hover {
    background-color: #f7f7f7;
  }
`;

const TriggerContent: React.FC<Props> = ({ name, series }) => {
  const { isOpen } = useDropdown();

  return isOpen ? (
    <SavedQueryButton isExistingLayer>{name}</SavedQueryButton>
  ) : (
    <SavedQueryLabel name={name} series={series} />
  );
};

export const SelectedSavedQueryLabel: React.FC<
  Props & { isInitiallyOpen?: boolean; onClick?: F0 }
> = ({ isInitiallyOpen = false, onClick, ...rest }) => (
  <Dropdown isInitiallyOpen={isInitiallyOpen}>
    <Dropdown.Trigger
      stopPropagation
      onClick={onClick}
      shouldToggleOnClick={false}
    >
      <TriggerContent {...rest} />
    </Dropdown.Trigger>
    <DropdownContent isExistingLayer />
  </Dropdown>
);
